module.exports = __webpack_public_path__ + "images/building.95827394a895ee6d05188ef50cb1183d.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/building.jpg
// module id = 982
// module chunks = 0